import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  { path: '', redirectTo: 'mi-poliza-digital', pathMatch: 'full' },
  {
    path: 'mi-poliza-digital',
    loadChildren: () => import('./components/home/landing-page-vdigital/landing-page-vdigital.module').then(m => m.LandingPageVDigitalModule)
  },
  {
    path: '**', pathMatch: 'full',
    loadChildren: () => import('./components/home/not-found/not-found.module').then(m => m.NotFoundModule)
  }
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: []
})
export class AppRoutingModule { }
